import { render, staticRenderFns } from "./payFees.vue?vue&type=template&id=38f24672&scoped=true&"
import script from "./payFees.vue?vue&type=script&lang=js&"
export * from "./payFees.vue?vue&type=script&lang=js&"
import style0 from "./payFees.vue?vue&type=style&index=0&id=38f24672&prod&lang=scss&scoped=true&"
import style1 from "./payFees.vue?vue&type=style&index=1&id=38f24672&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f24672",
  null
  
)

export default component.exports